/**
 * 몹 표를 **한 번만 받아 나눠 쓴다.**
 *
 * 표는 1.7MB 인데 화면 열여섯 군데가 이걸 받아 쓴다. 저마다 따로 부르면 탭을 옮길 때마다
 * 다시 받아 다시 파싱한다 — 서버가 304 로 끝내 주더라도(주소에 판 번호가 붙는다) 브라우저가
 * 1.7MB 를 다시 글자에서 객체로 푸는 값은 그대로 든다. 폰에서는 이게 눈에 띈다.
 *
 * 그래서 받은 것을 들고 있다가 그대로 돌려준다. 동시에 여러 군데서 불러도 **받는 일은
 * 한 번**이다(세는 중인 약속을 나눠 쓴다).
 *
 * 표를 고치는 화면(몬스터 관리)은 고친 뒤 새 표를 봐야 하므로 `refreshMonsterMapping()`
 * 을 쓴다 — 들고 있던 것을 버리고 다시 받는다.
 */

let cached: any = null;
let inFlight: Promise<any> | null = null;

async function fetchMapping(): Promise<any> {
  const res = await fetch('/api/monsters/monster-mapping');
  if (!res.ok) throw new Error(`몹 표를 받지 못했습니다 (${res.status})`);
  return res.json();
}

/** 들고 있으면 그대로, 없으면 받아서 들고 있는다 */
export function loadMonsterMapping(): Promise<any> {
  if (cached) return Promise.resolve(cached);
  if (inFlight) return inFlight;

  inFlight = fetchMapping()
    .then((data) => {
      cached = data;
      return data;
    })
    .finally(() => {
      inFlight = null;
    });
  return inFlight;
}

/** 표를 고친 뒤 — 들고 있던 것을 버리고 다시 받는다 */
export function refreshMonsterMapping(): Promise<any> {
  cached = null;
  inFlight = null;
  return loadMonsterMapping();
}
